<template>
    <div>
        <div class="text-sm uppercase">Custom Size</div>

        <div class="mt-3 flex items-end gap-2">
            <div>
                <div>
                    <label class="text-sm" for="custom-size-width">
                        Width
                    </label>
                </div>

                <EnhancedNumberInput
                    id="custom-size-width"
                    v-model="size.width"
                    class="w-24 rounded-md py-3 pl-5 pr-3 text-center outline-none ring-3 ring-inset ring-grind"
                    invalid-class="ring-red-700"
                    :min="2"
                    :max="12"
                    :step="0.01"
                />
            </div>

            <div class="text-xl leading-10">&times;</div>

            <div>
                <div>
                    <label class="text-sm" for="custom-size-height">
                        Height
                    </label>
                </div>

                <EnhancedNumberInput
                    id="custom-size-height"
                    v-model="size.height"
                    class="w-24 rounded-md py-3 pl-5 pr-3 text-center outline-none ring-3 ring-inset ring-grind"
                    invalid-class="ring-red-700"
                    :min="2"
                    :max="12"
                    :step="0.01"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import EnhancedNumberInput from '~/components/inputs/EnhancedNumberInput.vue';

const emit = defineEmits(['update:modelValue']);

const props = defineProps<{
    modelValue: {
        width: number;
        height: number;
    };
}>();

const size = ref(props.modelValue);

watch(
    () => props.modelValue,
    (newSize) => {
        Object.assign(size.value, newSize);
    },
);

watch(
    size,
    (newSize) => {
        emit('update:modelValue', { ...newSize });
    },
    { deep: true },
);
</script>
